import { toFixed } from "@/utils/math";
// import { mockDataList } from "./data";
/** 正弦波周期（秒），依次调用时同一 key 在该周期内完成一个波形 */
const SINE_PERIOD_SEC = 3;
const mockRangeMap = {
  // ==== 车身/转向/制动等通用信号（沿用原有配置） ====
  UIRx_DeltaOff_FA: [-1.5, 1.5],
  UIRx_DeltaOff_RA: [-1.5, 1.5],
  UIRx_AxleStAng_FA: [-50, 50],
  UIRx_AxleStAng_RA: [-10, 10],
  UIRx_mueFL: [0.1, 1],
  UIRx_mueFR: [0.1, 1],
  UIRx_mueRL: [0.1, 1],
  UIRx_mueRR: [0.1, 1],
  UIRx_TAAAct: [0, 1],
  UIRx_PitchAng: [-6, 6],
  UIRx_DMCTgtMod_FA: [0, 1],
  UIRx_DMCTgtMod_RA: [0, 1],
  UIRx_DMCWrkSt_FA: [0, 1],
  UIRx_DMCWrkSt_RA: [0, 1],
  UIRx_MotTq_FA: [-800, 800],
  UIRx_MotTq_RA: [-800, 800],
  UIRx_DUFlg_FL: [0, 1],
  UIRx_DUFlg_FR: [0, 1],
  UIRx_DUFlg_RL: [0, 1],
  UIRx_DUFlg_RR: [0, 1],
  UIRx_DUIdx_FL: [0, 63],
  UIRx_DUIdx_FR: [0, 63],
  UIRx_DUIdx_RL: [0, 63],
  UIRx_DUIdx_RR: [0, 63],
  UIRx_SuspHgtAmp_FL: [0, 1.6],
  UIRx_SuspHgtAmp_FR: [0, 1.6],
  UIRx_SuspHgtAmp_RL: [0, 1.6],
  UIRx_SuspHgtAmp_RR: [0, 1.6],
  UIRx_ACUYawRate: [-300, 300],
  UIRx_ACULongdAcc: [-5, 5],
  // CAN::ACULatAcc  横向加速度  -5 ~ 5
  UIRx_ACULatAcc: [-5, 5],
  UIRx_SBW_HWAAng: [-780, 780],
  UIRx_WhlBrkTqAct_FL_BCh1: [0, 4000],
  UIRx_WhlBrkTqAct_FR_BCh1: [0, 4000],
  UIRx_WhlBrkTqAct_RL_BCh1: [0, 4000],
  UIRx_WhlBrkTqAct_RR_BCh1: [0, 4000],
  UIRx_XCU_FrontAxleDecTorqReq: [0, 1],
  UIRx_XCU_RearAxleDecTorqReq: [0, 1],
  // CAN::VehSpd  当前车速  0 ~ 460.647
  UIRx_VehSpd: [0, 460.647],
  UIRx_FLWhlSpd_BCh1: [0, 460.688],
  UIRx_FRWhlSpd_BCh1: [0, 460.688],
  UIRx_RLWhlSpd_BCh1: [0, 460.688],
  UIRx_RRWhlSpd_BCh1: [0, 460.688],
  UIRx_ActuGearSta: [0, 7],
  UIRx_ABSSplitCtrlSts_BCh1: [0, 3],
  UIRx_DrvrReqTrgtFxBrk_Bch1: [-125000, 0],
  UIRx_VehSdsl: [0, 3],
  UIRx_alphaRA: [-25, 25],
  UIRx_OrgYawRate: [-300, 300],
  UIRx_FrontGearRto: [1, 4],
  UIRx_RearGearRto: [-0.32, 0.32],
  MCUF_MotToq: [-800, 800],
  MCUR_MotToq: [-800, 800],
  WhlBrkTqAct_FL_BCh1: [0, 1500],
  WhlBrkTqAct_FR_BCh1: [0, 1500],
  WhlBrkTqAct_RL_BCh1: [0, 1500],
  WhlBrkTqAct_RR_BCh1: [0, 1500],
  DrvrReqTrgtFxBrk_Bch1: [-20000, 0],
  UIRx_BrkPdlPositionAct: [0, 100],
  UIRx_MassEstiMod: [0, 3],
  UIRx_VehMass: [0, 5115],
  UIRx_FLVertDynF: [0, 25500],
  UIRx_FRVertDynF: [0, 25500],
  UIRx_RLVertDynF: [0, 25500],
  UIRx_RRVertDynF: [0, 25500],
  UIRx_FxyFL: [0, 25500],
  UIRx_FxyFR: [0, 25500],
  UIRx_FxyRL: [0, 25500],
  UIRx_FxyRR: [0, 25500],
  UIRx_ThetaFxyFA: [0, 359],
  UIRx_ThetaFxyRA: [0, 359],
  UIRx_BetaObs: [-25, 25],
  UIRx_AWSFrontAngAdd: [-1.275, 1.275],
  // HDC 相关
  UIRx_HDCAvlbl: [0, 1],
  UIRx_HDCDispVxTar: [0, 50],
  UIRx_HDCCtrlA: [-3, 3],
  UIRx_VAFBrkFxTrgt: [-20000, 0],
  // ICC 齿条/转向相关
  UIRx_PinionTarVgr: [-500, 500],
  UIRx_PinionAct: [-780, 780],
  // 旧 AccelDecelPitch 页面的 IMU 信号（保留原有范围）
  SusIMUPitchAngle: [-2, 2],
  SusIMUPitch: [-4, 4],
  SusIMURollAngle: [-5, 5],
  SusIMURoll: [-5, 5],
  SusBodySpdVert: [-1, 1],
  EPS_StrgAngSpeed: [-60, 60],
  EPS_StrgAng: [-100, 100],
  VehSpd: [0, 460.647],

  // ==== 文档《X11底盘能力展示科目-开发文档》对应 SOA/CAN 信号范围 ====

  // 云台模式 & 弯道侧倾：俯仰角 / 侧倾角  -360 ~ 360
  MSG_ASUBodyPitchAng: [-10, 10],
  MSG_ASUBodyRollAng: [-10, 10],

  // 加减速俯仰 & 侧面防碰撞：四轮高度  -120 ~ 120 mm
  MSG_SusHghtLvlSnsrFL: [-120, 120],
  MSG_SusHghtLvlSnsrFR: [-120, 120],
  MSG_SusHghtLvlSnsrRL: [-120, 120],
  MSG_SusHghtLvlSnsrRR: [-120, 120],

  // 弹射起步：请求 & 状态
  SRV_LaunchControlReq: [0, 2],
  MSG_LaunchControlSts: [0, 255],

  // 紧急举升请求
  SRV_EmergLvlngReq: [0, 2],

  // 齿条 / 转向
  MSG_Rwa1RackPosn: [-120, 120],
  MSG_Rwa2RackPosn: [-120, 120],
  MSG_SBWHWAAng: [-780, 780],
  MSG_RrStRackPstnAct: [-32, 32],

  // 弯道制动相关
  MSG_Icc_betaEst_rad: [-1.1, 1.1],
  MSG_Vsm_VehRefSpdEst_kph: [0, 200],
  MSG_Icc_AlphaFAObs_rad: [-1.1, 1.1],
  MSG_Icc_AlphaRAObs_rad: [-1.1, 1.1],

  // 单轮失效：轮端夹紧力 0 ~ 81915 N
  MSG_WhlClmpFAct_FL_C1: [0, 81915],
  MSG_WhlClmpFAct_FR_C1: [0, 81915],
  MSG_WhlClmpFAct_RL_C1: [0, 81915],
  MSG_WhlClmpFAct_RR_C1: [0, 81915],
  WhlClmpFAct_FL_C1: [0, 81915],
  WhlClmpFAct_FR_C1: [0, 81915],
  WhlClmpFAct_RL_C1: [0, 81915],
  WhlClmpFAct_RR_C1: [0, 81915],

  // 预留信号 SRV_ModResdSig1（uint8 0~255）
  SRV_ModResdSig1: [0, 255],

  // 弯道侧倾页面内部使用的派生量（侧加 / 侧倾角 / 梯度）保持 UI 设计范围
  ACULatAcc: [-1.2, 1.2], // 侧加
  PitchAngle: [-3, 3], // 侧倾角
  RollAngle: [-3, 3], // 侧倾梯度
  SBW_HWAAng: [-300, 300],
  // 伏路调平
  MSG_SusIMUAccVert: [-3, 3],
  MSG_SusIMURoll: [-250, 250],
  MSG_SusIMUPitch: [-250, 250],
  // 方向盘转角
  MSG_EPSStrgAng: [-500, 500],
  // 悬架车身侧倾角
  ASUBodyRollAng: [-3, 3],
  
} as Dictionary<any>;

/** 根据 key（通常为 displayName）获取预设范围，未配置则返回 undefined */
export function getRangeByKey(key: string): [number, number] | undefined {
  return (mockRangeMap as any)[key];
}

/**
 * 从 SOA 全名解析 mock 表使用的短 key（如 SOA::SuspensionSts_MSG_ASUBodyRollAng → MSG_ASUBodyRollAng）
 */
export function getMockKeyForSoaProperty(propertyName: string): string {
  if ((mockRangeMap as any)[propertyName] !== undefined) {
    return propertyName;
  }
  const tail = propertyName.includes("::")
    ? propertyName.split("::").pop()!
    : propertyName;
  const msg = tail.match(/MSG_[A-Za-z0-9_]+$/);
  if (msg) {
    return msg[0];
  }
  const srv = tail.match(/SRV_[A-Za-z0-9_]+$/);
  if (srv) {
    return srv[0];
  }
  return tail;
}

/** SOA 属性名 → 图表 / mock 使用的 [min, max]，与 mockRangeMap 对齐 */
export function getRangeForSoaProperty(propertyName: string): [number, number] {
  const direct = getRangeByKey(propertyName);
  if (direct) {
    return direct;
  }
  const key = getMockKeyForSoaProperty(propertyName);
  const byKey = getRangeByKey(key);
  if (byKey) {
    return byKey;
  }
  if (
    key.includes("SBW_HWAAng") ||
    propertyName.includes("SBW_HWAAng")
  ) {
    const a = getRangeByKey("MSG_SBWHWAAng");
    if (a) {
      return a;
    }
  }
  console.warn(`[mock] getRangeForSoaProperty 未配置，使用 [0,1]: ${propertyName}`);
  return [0, 1];
}

/**
 * 在 range [min, max] 内生成正弦波上的值：value = min + (max - min) * (sin(phase) + 1) / 2
 * 依次调用时基于时间产生连续正弦波，每个 key 带不同相位偏移避免重叠
 */
function getSineValueInRange(min: number, max: number, phase: number): number {
  const normalized = (Math.sin(phase) + 1) / 2; // [0, 1]
  const value = min + (max - min) * normalized;
  return Number(toFixed(value, 4));
}

// 给定 keys 返回 mock 数据（正弦波，在 range 范围内）
export const getMockDataByKeys = (keys: string[], newRangeMap = {}) => {
  const rangeMap = Object.assign({}, mockRangeMap, newRangeMap);
  const t = Date.now() * 0.001; // 秒
  const basePhase = (2 * Math.PI * t) / SINE_PERIOD_SEC;
  const data = keys.reduce((per, key, index) => {
    let range = rangeMap[key];
    if (!range) {
      range = [0, 1];
      console.warn(`getMockDataByKeys ${key} 没有找到范围`);
    }
    const [min, max] = range;
    const phaseOffset = (index * 2 * Math.PI) / Math.max(keys.length, 1);
    const phase = basePhase + phaseOffset;
    per[key] = getSineValueInRange(min, max, phase);
    return per;
  }, {} as any);
  return data;
};
